import { Label } from '@/components/shadcn/ui/label';
import { Switch } from '@/components/shadcn/ui/switch';
import {
  ToggleGroup,
  ToggleGroupItem,
} from '@/components/shadcn/ui/toggle-group';

import { useSharedLinkQuery } from '../api';
import { useSharedLinkUpdate } from '../hooks';
import { formatExpireDate } from '../lib';
import type { LinkExpireMode } from '../model';
import { useSharedLinkForm } from './shared-link-form-context';

const EXPIRE_OPTIONS: { value: LinkExpireMode; label: string }[] = [
  { value: '7days', label: '7 days' },
  { value: '30days', label: '30 days' },
  { value: '60days', label: '60 days' },
  { value: '90days', label: '90 days' },
];

export function LinkExpireSettings() {
  const form = useSharedLinkForm();
  const { saveChanges } = useSharedLinkUpdate(form);
  const { data: sharedLinkData } = useSharedLinkQuery(
    form.getFieldValue('sharedLinkId'),
  );

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-0.5">
          <Label className="text-sm font-medium text-gray-900">
            Link expiration
          </Label>
          <form.Subscribe
            selector={(state: any) => ({
              enabled: state.values.linkExpireEnabled,
              mode: state.values.linkExpireMode,
            })}
            children={({ enabled, mode }: any) =>
              enabled && (
                <span className="text-xs text-gray-500">
                  {formatExpireDate(mode, sharedLinkData?.updated_at)}
                </span>
              )
            }
          />
        </div>
        <form.AppField
          name="linkExpireEnabled"
          children={(field: any) => (
            <Switch
              checked={field.state.value ?? false}
              onCheckedChange={(checked) => {
                field.handleChange(checked);
                saveChanges();
              }}
            />
          )}
        />
      </div>

      <form.AppField
        name="linkExpireEnabled"
        children={(enabledField: any) =>
          enabledField.state.value && (
            <form.AppField
              name="linkExpireMode"
              children={(field: any) => (
                <ToggleGroup
                  type="single"
                  value={field.state.value ?? ''}
                  onValueChange={(value) => {
                    if (value) {
                      field.handleChange(value as LinkExpireMode);
                      saveChanges();
                    }
                  }}
                  spacing={1}
                  variant="outline"
                >
                  {EXPIRE_OPTIONS.map((option) => (
                    <ToggleGroupItem key={option.value} value={option.value}>
                      {option.label}
                    </ToggleGroupItem>
                  ))}
                </ToggleGroup>
              )}
            />
          )
        }
      />
    </div>
  );
}
